import { Stack, TextField } from '@mui/material';
import { ICaseDetailsInputs } from 'API';
import { CustomRadioGroup, RadioButtons } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useAppSelector, useDictionary } from 'Hooks';
import { IndexContext } from 'Modules/CaseDetails/CaseContext';
import { useContext } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { generateError } from 'Regex';
import { styleTextField } from 'Theme';
import { validateLettersAndNumbersOnly } from 'Utils/validateLettersAndNumbersOnly';

export const ON_THE_WAY_TO_BASE_OR_FROM_BASE = 2;

export const WhenInjuryHappened = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<ICaseDetailsInputs>();
  const { index } = useContext(IndexContext);

  const [whenInjuryHappanedOptions] = useAppSelector(
    ({
      generalContent: {
        generalContent: { whenInjuryHappanedOptions },
      },
    }) => [whenInjuryHappanedOptions]
  );

  const baseName = `caseDetails.${index}.injuryKindSection`;

  const whenInjuryHappaned = useWatch({
    name: `${baseName}.whenInjuryHappanedOptionId`,
  }) as number;
  const didStop = useWatch({
    name: `${baseName}.isStopedOnIntermediateDest`,
  });

  const dictionary = useDictionary(Dictionary, DICTIONARY.CASE_DETAILS);

  const injuryServiceError = errors.caseDetails
    ? errors.caseDetails[index]?.injuryKindSection
    : undefined;

  return (
    <>
      <CustomRadioGroup
        id={dictionary.secondSectionWhenHappened}
        removeBold
        name={`${baseName}.whenInjuryHappanedOptionId` as const}
        options={whenInjuryHappanedOptions.map(({ id, value }) => ({
          value: id.toString(),
          label: value,
        }))}
      />
      {whenInjuryHappaned == ON_THE_WAY_TO_BASE_OR_FROM_BASE && (
        <Stack gap='24px'>
          <TextField
            id={`${dictionary.secondSectionBaseLocation}-${index}`}
            label={dictionary.secondSectionBaseLocation}
            inputProps={{
              maxLength: '50',
            }}
            {...register(
              `${baseName}.militaryBaseLocation` as `caseDetails.0.injuryKindSection.militaryBaseLocation`
            )}
            onChange={(event: any) => validateLettersAndNumbersOnly(event)}
            sx={styleTextField}
            role={
              Boolean(injuryServiceError?.militaryBaseLocation)
                ? 'alert'
                : undefined
            }
            error={Boolean(injuryServiceError?.militaryBaseLocation)}
            helperText={
              Boolean(injuryServiceError?.militaryBaseLocation?.message) &&
              generateError(
                dictionary.secondSectionBaseLocation,
                injuryServiceError?.militaryBaseLocation?.message!
              )
            }
          />
          <TextField
            id={`${dictionary.secondSectionAddress}-${index}`}
            label={dictionary.secondSectionAddress}
            inputProps={{
              maxLength: '50',
            }}
            {...register(
              `${baseName}.residentiaAddress` as `caseDetails.0.injuryKindSection.residentiaAddress`
            )}
            onChange={(event: any) => validateLettersAndNumbersOnly(event)}
            sx={styleTextField}
            role={
              Boolean(injuryServiceError?.residentiaAddress)
                ? 'alert'
                : undefined
            }
            error={Boolean(injuryServiceError?.residentiaAddress)}
            helperText={
              Boolean(injuryServiceError?.residentiaAddress?.message) &&
              generateError(
                dictionary.secondSectionAddress,
                injuryServiceError?.residentiaAddress?.message!
              )
            }
          />
          <TextField
            id={`${dictionary.secondSectionInjuryLocation}-${index}`}
            label={dictionary.secondSectionInjuryLocation}
            inputProps={{
              maxLength: '50',
            }}
            {...register(
              `${baseName}.injuryLocation` as `caseDetails.0.injuryKindSection.injuryLocation`
            )}
            onChange={(event: any) => validateLettersAndNumbersOnly(event)}
            sx={styleTextField}
            role={
              Boolean(injuryServiceError?.injuryLocation) ? 'alert' : undefined
            }
            error={Boolean(injuryServiceError?.injuryLocation)}
            helperText={
              Boolean(injuryServiceError?.injuryLocation?.message) &&
              generateError(
                dictionary.secondSectionInjuryLocation,
                injuryServiceError?.injuryLocation?.message!
              )
            }
          />
          <RadioButtons
            id={dictionary.secondSectionDidStop}
            name={`${baseName}.isStopedOnIntermediateDest`}
            options={[
              {
                value: 'true',
                label: dictionary.secondSectionFamilyInjuryYes,
              },
              {
                value: 'false',
                label: dictionary.secondSectionFamilyInjuryNo,
              },
            ]}
          />
          {didStop && (
            <TextField
              id={`${dictionary.secondSectionStopPurpose}-${index}`}
              label={dictionary.secondSectionStopPurpose}
              inputProps={{
                maxLength: '50',
              }}
              {...register(
                `${baseName}.stopPurpose` as `caseDetails.0.injuryKindSection.stopPurpose`
              )}
              onChange={(event: any) => validateLettersAndNumbersOnly(event)}
              role={
                Boolean(injuryServiceError?.stopPurpose) ? 'alert' : undefined
              }
              error={Boolean(injuryServiceError?.stopPurpose)}
              helperText={
                Boolean(injuryServiceError?.stopPurpose?.message) &&
                generateError(
                  dictionary.secondSectionStopPurpose,
                  injuryServiceError?.stopPurpose?.message!
                )
              }
              sx={styleTextField}
            />
          )}
        </Stack>
      )}
    </>
  );
};
